'use strict';

import angular from 'angular';
import Main from './formation.controller';

export default angular.module('aperamApp.borne.formation', [])
  .controller('FormationController', Main)
  .name;


// WEBPACK FOOTER //
// ./client/app/borne/formation/index.js